import { ThgHttpClientProvider } from "@/services/thg/thg-http-client.provider";
import { Banking } from "../v1/Banking";
import {
  ThgBankingControllerGetBankingParamsGen,
  ThgBankingControllerNewBankingParamsGen,
  ThgBankingDtoGen
} from "../v1/data-contracts";
import { HttpClient } from "../v1/http-client";

/**
 * Communicates with the thg module (implementet in thg api)
 */
class BankService {
  /**
   * The HttpClient containing the Axios Instance
   */
  client: HttpClient;

  /**
   * The proxy.
   */
  proxy: Banking;

  /**
   * @class Initialize ThgService
   */
  constructor(clientProvider: ThgHttpClientProvider) {
    this.client = clientProvider.client();
    this.proxy = new Banking(this.client);
  }

  /**
   *
   * Gets the Bankinginformation of a User by AuthInfo
   *
   * @returns
   */
  async getMyBanking(): Promise<ThgBankingDtoGen> {
    const response = await this.proxy.bankingControllerGetMyBankingInformation();
    return response.data;
  }

  /**
   *
   * Create or update the Bankinginformation fo a User by Authinfo
   *
   * @param dto
   * @returns
   */
  async createOrUpdateMyBanking(dto: ThgBankingDtoGen): Promise<ThgBankingDtoGen> {
    const response = await this.proxy.bankingControllerCreateOrUpdateBankingMe(dto);
    return response.data;
  }

  /**
   *
   * Creates Bankinginformation for a User
   *
   * @param dto
   * @returns
   */
  async createBanking(
    query: ThgBankingControllerNewBankingParamsGen,
    dto: ThgBankingDtoGen
  ): Promise<ThgBankingDtoGen> {
    const response = await this.proxy.bankingControllerNewBanking(query, dto);
    return response.data;
  }

  /**
   *
   * Gets the Bankinginformation of a User by AuthInfo
   *
   * @returns
   */
  async getBanking(dto: ThgBankingControllerGetBankingParamsGen): Promise<ThgBankingDtoGen> {
    const response = await this.proxy.bankingControllerGetBanking(dto);
    return response.data;
  }
}

export default new BankService(new ThgHttpClientProvider());
